<script lang="ts" setup>
export interface Component
{
    name: string;
    label: string;
    visible: boolean;
    index: number;
    instance: any;
}

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const search = ref('');
const resetSearch = (): void =>
{
    search.value = '';
};

const model = ref([] as string[]);
const visible = inject<Ref<string[]>>('visible');
const components = inject<Ref<Component[]>>('components');
const items = computed(() =>
{
    return components.value
        .where(p => p.name.toLowerCase().includes(search.value.toLowerCase()))
        .orderBy(p => p.index)
        .toArray();
});

watch(visible, (value) =>
{
    model.value = value;
});

const saveVisible = (): void =>
{
    visible.value = model.value;
};

const resetVisible = (): void =>
{
    model.value = components.value
        .where(p => p.visible)
        .select(p => p.name)
        .toArray();

    saveVisible();
};

function onChange(value: any[], old: any[])
{
    if (value.length > old.length)
    {
        saveVisible();

        const name = value.filter(p => !old.includes(p)).first();

        components.value.filter(c => c.name == name).forEach((c) =>
        {
            c.instance.exposed.open();
        });

        emit('close');
    }

    if (value.length < old.length)
    {
        saveVisible();
    }
}

onMounted(async () =>
{
    resetVisible();
});
</script>

<template>
    <IdeoInputGroup class="border-bottom">
        <IdeoFormInput v-model="search" type="text" name="search" :placeholder="$t('[[[Wyszukaj...]]]')" class="bg-body py-3 border-0" />
        <template #append>
            <IdeoButton variant="link" icon="fas fa-fw fa-times" @click="resetSearch()" />
        </template>
    </IdeoInputGroup>
    <div class="filters scroll py-1">
        <IdeoFormCheckboxGroup
            v-if="items.length > 0"
            v-model="model"
            name="components"
            :options="items"
            value-field="name"
            text-field="label"
            stacked
            @change="onChange"
        />
        <div v-else class="text-center p-5">
            {{ $t('[[[Nie znaleziono żadnego pola.]]]') }}
        </div>
    </div>
    <div v-if="components.length == 0" class="d-flex justify-content-center py-3">
        {{ $t('[[[Nie znaleziono filtrów.]]]') }}
    </div>
    <div class="d-flex justify-content-end align-items-center border-top p-2">
        <div>{{ $t('[[[%0 z %1|||{0}|||{1}]]]', model.length.toString(), components.length.toString()) }}</div>
    </div>
</template>

<style lang="scss" scoped>
.filters {
    max-height: 295px;

    :deep(fieldset) {
        padding: 0;
    }
    :deep(.form-check) {
        margin: 0 !important;
        padding: 0 8px 0 8px;
        border-left: 3px solid transparent;

        &:hover {
            background-color: var(--bs-tertiary-bg);
            border-left-color: var(--bs-primary)
        }

        label {
            margin: 0 !important;
            padding: 8px 0 8px 8px;
            display: block;
            cursor: pointer;
        }
    }
}
</style>
